/**
 * Gallery Builder Configuration
 */
const GALLERY_CONFIG = {
  PERFORMANCE: {
    FETCH_TIMEOUT: 15000,
    SEARCH_DEBOUNCE: 300,
    PRELOAD_BATCH_SIZE: 5,
    RETRY_LIMIT: 3,
    RETRY_DELAY: 3000,
    SLOW_OPERATION_THRESHOLD: 50,
    PERFORMANCE_LOG_INTERVAL: 30000
  },
  DISPLAY: {
    DEFAULT_VARIANT_PRIORITY: ['Exhibition', 'Collector', 'Large'],
    THUMBNAIL_SIZES: [80, 160],
    IMAGE_LOADING_STRATEGY: 'progressive'
  },
  API: {
    COLLECTION_ENDPOINT: '/collections/all/products.json',
    MAX_PRODUCTS_PER_REQUEST: 250,
  },
  TRANSITIONS: {
    GRID_DURATION: 300,
    FADE_DURATION: 300,
    ORIENTATION_DELAY: 150,
    RANDOMIZE_DELAY: 150,
    LOADING_FADEOUT_DELAY: 700,
    LOADING_TEXT_CHANGE_DELAY: 300,
    LOADING_FINAL_DELAY: 1000
  },
  LOADING: {
    TEXT_CYCLE_DURATION: 3000,
    PROGRESS_INCREMENT: 1.5,
    PROGRESS_ANIMATION_INTERVAL: 800,
    INITIAL_PROGRESS: 25,
    FETCH_PROGRESS: 50,
    TRANSFORM_PROGRESS: 75,
    PRELOAD_PROGRESS: 80,
    COMPLETE_PROGRESS: 100
  },
  LAYOUT: {
    DUO_COUNT: 2,
    TRIO_COUNT: 3,
    DEFAULT_LAYOUT_COUNT: 2,
    DEFAULT_ORIENTATION: 'horizontal',
    MIN_CAROUSEL_INDEX: 0
  },
  BOOST: {
    API_URL: 'https://services.mybcapps.com',
    CACHE_TTL: 30 * 60 * 1000,
    RESULT_CACHE_TTL: 5 * 60 * 1000,
    FILTER_DEBOUNCE: 300,
    API_TIMEOUT: 10000,
    MAX_PRODUCTS_PER_REQUEST: 70
  }
};


function getConfig(section, key, fallback = null) {
  if (GALLERY_CONFIG[section] && GALLERY_CONFIG[section][key] !== undefined) {
    return GALLERY_CONFIG[section][key];
  }

  if (fallback !== null) {
    return fallback;
  }

  return null;
}

export { GALLERY_CONFIG, getConfig };